import { render } from "./PolicyBranchList.vue?vue&type=template&id=b36c44a6&scoped=true"
import script from "./PolicyBranchList.vue?vue&type=script&lang=js"
export * from "./PolicyBranchList.vue?vue&type=script&lang=js"

import "./PolicyBranchList.vue?vue&type=style&index=0&id=b36c44a6&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b36c44a6"]])

export default __exports__